module.exports = __webpack_public_path__ + "static/media/chat03-2.f514b40f.svg";